export class TokenExpired {
  static readonly type = '[Authentication] Token Expired';
  constructor() {}
}
